import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";

import { DespatchTask } from "Models/despatch.task";

import { DiarySeeManyTaskDrawer } from "./DiarySeeManyTaskDrawer";
import { DiarySeeOneTaskPopup } from "./DiarySeeOneTaskPopup";
import { DiarySeeTasksHandles, DiarySeeTasksProps } from "./types";

const DiarySeeTasksComp: ForwardRefRenderFunction<DiarySeeTasksHandles, DiarySeeTasksProps> = (
  { viewMode },
  ref
) => {
  const [oneTaskModalopened, setOneTaskModalOpened] = useState<boolean>(false);
  const [manyTasksModalOpened, setManyTasksModalOpened] = useState<boolean>(false);
  const [tasks, setTasks] = useState<DespatchTask[]>([]);
  const [daySelected, setDaySelected] = useState<Date | null>(null);

  const openModal = useCallback((tasks: DespatchTask[], dateSelected?: Date) => {
    setTasks(tasks);
    setDaySelected(dateSelected || null);
    if (tasks && tasks.length > 0) {
      if (tasks.length > 1) setManyTasksModalOpened(true);
      if (tasks.length === 1) setOneTaskModalOpened(true);
    }
  }, []);

  const closeModal = useCallback(() => {
    setOneTaskModalOpened(false);
    setManyTasksModalOpened(false);
    setTasks([]);
    setDaySelected(null);
  }, []);

  useImperativeHandle(ref, () => ({
    open: openModal,
    close: closeModal,
  }));

  const onChangeToOneTask = (task: DespatchTask) => {
    setTasks([task]);
    setManyTasksModalOpened(false);
    setTimeout(() => {
      setOneTaskModalOpened(true);
    }, 100);
  };

  return (
    <>
      <DiarySeeManyTaskDrawer
        isOpen={manyTasksModalOpened}
        tasks={tasks}
        daySelected={daySelected}
        onCloseModal={closeModal}
        viewMode={viewMode}
        onChangeToOneTask={onChangeToOneTask}
      />

      <DiarySeeOneTaskPopup
        isOpen={oneTaskModalopened}
        task={tasks[0]}
        onCloseModal={closeModal}
        viewMode={viewMode}
      />
    </>
  );
};

export const DiarySeeTasks = forwardRef(DiarySeeTasksComp);
export * from "./types";
